// ModalSms.jsx
import React from "react";
import Modal from "react-modal";
import { Smartphone } from "lucide-react";

const customStyles = {
  overlay: {
    position: "fixed",
    inset: 0,
    backgroundColor: "rgba(0,0,0,0.35)",
    display: "grid",
    placeItems: "center",
    zIndex: 1010,
    padding: 16,
  },
  content: {
    position: "relative",
    inset: "auto",
    width: "100%",
    maxWidth: 560,
    borderRadius: 22,
    padding: 0,
    border: "1px solid #eef2f7",
    boxShadow: "0 18px 50px rgba(15, 23, 42, 0.18)",
    overflow: "hidden",
    background: "#ffffff",
    outline: "none",
    boxSizing: "border-box",
    fontFamily: "Inter, sans-serif",
  },
};

export default function ModalSms({
  isOpen,
  onClose,
  phoneDisplay,
  onConfirmSend,
  loading = false,
}) {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      shouldCloseOnOverlayClick={!loading}
      shouldCloseOnEsc={!loading}
      style={customStyles}
    >
      <div style={{ padding: "28px 28px 22px" }}>
        {/* Icono */}
        <div
          style={{
            width: 70,
            height: 70,
            borderRadius: 999,
            border: "3px solid #38BDF8",
            display: "grid",
            placeItems: "center",
            margin: "0 auto 14px",
          }}
        >
          <span style={{ fontSize: 34, color: "#38BDF8", fontWeight: 700 }}>
            i
          </span>
        </div>

        <h2
          style={{
            textAlign: "center",
            fontWeight: 700,
            margin: "6px 0 12px",
            color: "#374151",
            fontSize: 28,
          }}
        >
          Activar con SMS
        </h2>

        <p
          style={{ textAlign: "center", color: "#6B7280", margin: "0 0 16px" }}
        >
          Se enviará un código de verificación a tu número de teléfono
          registrado.
        </p>

        {/* Teléfono (solo lectura) */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 10,
            border: "1px solid #e5e7eb",
            background: "#f9fafb",
            borderRadius: 10,
            padding: "12px 14px",
            marginTop: 10,
          }}
        >
          <Smartphone
            size={18}
            style={{ color: "#6B7280", flex: "0 0 auto" }}
          />
          <input
            value={phoneDisplay || ""}
            readOnly
            style={{
              width: "100%",
              border: 0,
              outline: "none",
              background: "transparent",
              fontSize: 16,
              color: "#111827",
            }}
          />
        </div>

        <p style={{ color: "#9CA3AF", marginTop: 10, fontSize: 13 }}>
          Pueden aplicarse cargos por SMS según tu operador
        </p>

        {/* Botones */}
        <div
          style={{
            marginTop: 18,
            display: "flex",
            justifyContent: "center",
            gap: 12,
            fontFamily: "Inter, sans-serif",
          }}
        >
          <button
            type="button"
            onClick={onConfirmSend}
            disabled={loading || !phoneDisplay}
            style={{
              height: 42,
              padding: "0 18px",
              borderRadius: 8,
              border: 0,
              backgroundColor: "#4F46E5",
              color: "#fff",
              fontWeight: 700,
              cursor: loading ? "not-allowed" : "pointer",
              opacity: loading ? 0.75 : 1,
            }}
          >
            {loading ? "Enviando..." : "Enviar código"}
          </button>

          <button
            type="button"
            onClick={onClose}
            disabled={loading}
            style={{
              height: 42,
              padding: "0 18px",
              borderRadius: 8,
              border: 0,
              background: "#6B7280",
              color: "#fff",
              fontWeight: 700,
              cursor: loading ? "not-allowed" : "pointer",
              opacity: loading ? 0.75 : 1,
            }}
          >
            Cancelar
          </button>
        </div>
      </div>
    </Modal>
  );
}
